export default __webpack_public_path__ + "images/eecfa9479d8ba60628862052aa5f14b7-motorcycle_small.webp";